import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BzgModalService, BzgToastService } from "bz-genome-angular";
import { I18nService } from "i18n/i18n.service";
import { DeleteConfirmationComponent } from "app/shared/components/delete-confirmation/delete-confirmation.component";
import { WorkingTimeSchemaModalComponent } from "../working-time-schema-modal/working-time-schema-modal.component";

@Component({
  selector: 'working-time-schema-table',
  templateUrl: 'working-time-schema-table.component.html',
  styleUrls: ['working-time-schema-table.component.scss']
})

export class WorkingTimeSchemaTableComponent implements OnChanges{
  public nonWorkingTimeSchemaUser = [];
  public workingTimeSchemaUser = [];
  public columnCount = 5;
  public seletedWorkingTimeSchema = null;

  @Input() datesCustomUserTableInput;
  @Input() isWorking = false;
  
  @Output() emitNewDateCustomUser = new EventEmitter();
  @Output() emitEditDateCustomUser = new EventEmitter();
  @Output() emitDeleteDateCustomUser = new EventEmitter();

  constructor(
    private _i18nService: I18nService,
    private _modalService: BzgModalService) {
  }

  ngOnChanges() {
    if (this.datesCustomUserTableInput)
      this.setDataWorkingTimeSchema();
    if (this.isWorking)
      this.columnCount = 6;
    else 
      this.columnCount = 5;
  }

  setDataWorkingTimeSchema() {
    this.nonWorkingTimeSchemaUser = [];
    this.workingTimeSchemaUser = [];
    this.datesCustomUserTableInput.forEach(customDay => {
      if (customDay.isWorking) {
        this.workingTimeSchemaUser.push({
          fromDate: customDay.fromDate,
          toDate: customDay.toDate,
          days: this.getDaysBetween(customDay.fromDate, customDay.toDate),
          idUser: customDay.idUser,
          idWorkingTimeData: customDay.idWorkingTimeData,
          isWorking: customDay.isWorking,
          idEdit: customDay.idEdit,
          toTime1: customDay.toTime1,
          toTime2: customDay.toTime2,
          toTime3: customDay.toTime3,
          toTime4: customDay.toTime4,
          toTime5: customDay.toTime5,
          fromTime1: customDay.fromTime1,
          fromTime2: customDay.fromTime2,
          fromTime3: customDay.fromTime3,
          fromTime4: customDay.fromTime4,
          fromTime5: customDay.fromTime5
        });

        this.workingTimeSchemaUser.sort((a, b) => new Date(a.fromDate).getTime() - new Date(b.fromDate).getTime());
        
      }
      else {
        this.nonWorkingTimeSchemaUser.push({
          fromDate: customDay.fromDate,
          toDate: customDay.toDate,
          days: this.getDaysBetween(customDay.fromDate, customDay.toDate),
          idUser: customDay.idUser,
          idWorkingTimeData: customDay.idWorkingTimeData,
          isWorking: customDay.isWorking,
          idEdit: customDay.idEdit,
          toTime1: customDay.toTime1,
          toTime2: customDay.toTime2,
          toTime3: customDay.toTime3,
          toTime4: customDay.toTime4,
          toTime5: customDay.toTime5,
          fromTime1: customDay.fromTime1,
          fromTime2: customDay.fromTime2,
          fromTime3: customDay.fromTime3,
          fromTime4: customDay.fromTime4,
          fromTime5: customDay.fromTime5
        });

        this.nonWorkingTimeSchemaUser.sort((a, b) => new Date(a.fromDate).getTime() - new Date(b.fromDate).getTime());
      }
    });
  }

  getDaysBetween(startDate: Date, endDate: Date): number {
    const oneDay = 24 * 60 * 60 * 1000;
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const diffInMilliseconds = Math.abs(end - start);
    return Math.floor(diffInMilliseconds / oneDay) + 1;
  }

  addWorkingTimeSchema() {
    const title = this.isWorking ? 'WORKING_TIME_SCHEMA.ADDITIONAL_WORKING_HOURS_ADD' : 'WORKING_TIME_SCHEMA.ADDITIONAL_NON_WORKING_HOURS_ADD';
    const modal = this._modalService.open(WorkingTimeSchemaModalComponent, {
      closeOnBackdropClick: false,
      width: '500px',
      maxWidth: 'none',
      maxHeight: this.isWorking ? '100%': '52%',
      closeOnRouterNavigation: true,
      data: { title, button : 'GLOBAL.ADD', workingTimeSchema: null, isWorking : this.isWorking }
    });

    modal.afterClosed().subscribe(newWorkingTimeSchema => {
      if (newWorkingTimeSchema)
        this.emitNewDateCustomUser.emit(newWorkingTimeSchema);
    });
  }

  editWorkingTimeSchema(workingTimeSchema) {
    const title = this.isWorking ? 'WORKING_TIME_SCHEMA.ADDITIONAL_WORKING_HOURS_ADD' : 'WORKING_TIME_SCHEMA.ADDITIONAL_NON_WORKING_HOURS_ADD';
    const modal = this._modalService.open(WorkingTimeSchemaModalComponent, {
      closeOnBackdropClick: false,
      width: '500px',
      maxWidth: 'none',
      maxHeight: this.isWorking ? '100%': '52%',
      closeOnRouterNavigation: true,
      data: { title, button : 'GLOBAL.UPDATE', workingTimeSchema, isWorking : this.isWorking  }
    });

    modal.afterClosed().subscribe(editWorking => {
      if (editWorking) {
        if (editWorking.currentDateType === 'exact') {
          workingTimeSchema.days = this.getDaysBetween(editWorking.onDate, editWorking.onDate);
          workingTimeSchema.fromDate = editWorking.onDate;
          workingTimeSchema.toDate = editWorking.onDate;
        }  else {
          workingTimeSchema.days = this.getDaysBetween(editWorking.startDate, editWorking.finishDate);
          workingTimeSchema.fromDate = editWorking.startDate;
          workingTimeSchema.toDate = editWorking.finishDate;
        }

        for (let i = 1; i <= 5; i++) {
          workingTimeSchema[`fromTime${i}`] = editWorking[`fromTime${i}`];
          workingTimeSchema[`toTime${i}`] = editWorking[`toTime${i}`];
        }
        
        this.emitEditDateCustomUser.emit(workingTimeSchema);
      }
    });
  }

  deleteWorkingTimeSchema(workingTimeSchema) {
    const title = this.isWorking ? this._i18nService.instant('WORKING_TIME_SCHEMA.DELETE_TITLE_WORKING') : this._i18nService.instant('WORKING_TIME_SCHEMA.DELETE_TITLE_NON_WORKING');
    const message = this.isWorking ? this._i18nService.instant('WORKING_TIME_SCHEMA.DELETE_MESSAGE_WORKING'): this._i18nService.instant('WORKING_TIME_SCHEMA.DELETE_MESSAGE_NON_WORKING');
    const modal = this._modalService.open(DeleteConfirmationComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: { title, message, button: 'GLOBAL.DELETE' }
    });
    modal.afterClosed().subscribe((result) => {
      if (result === 'delete') {
        this.emitDeleteDateCustomUser.emit(workingTimeSchema);
      }
    });
  }

  openTimeDetails(workingTimeShcme) {
    this.seletedWorkingTimeSchema = workingTimeShcme;
  }
}